import * as React from "react";
import PropTypes from "prop-types";
import { Box, TextField, FormHelperText } from "@mui/material";

export default class CustomTextField extends React.Component {
  render() {
    const { label, error, defaultValue, value, fontSize, height, rows, onBlurFunc, inputProps, helperText } = this.props;
    var modifiedLabel = label.replaceAll(" ", "").toLocaleLowerCase();

    return (
      <Box autoComplete="off" mb={3}>
        <TextField
          id={`${modifiedLabel}-id-auto-select`}
          fullWidth
          label={label}
          variant="standard"
          multiline
          defaultValue={defaultValue}
          value={value}
          InputProps={{
            ...inputProps,
            style: { fontSize: fontSize,
                      height: height
                     },
          }}
          rows={rows}
          error={error}
          onBlur={(e) => onBlurFunc && onBlurFunc(e, modifiedLabel)}
          InputLabelProps={{ style: { fontSize: fontSize, height: height}, shrink: true }}

        />
        <FormHelperText error={error} id={`${modifiedLabel}-id-dropdown-helper-text`}>
            {helperText}
          </FormHelperText>
      </Box>
    );
  }
}

CustomTextField.propTypes = {
  label: PropTypes.string,
  defaultValue: PropTypes.string,
  value: PropTypes.string,
  fontSize: PropTypes.number,
  height: PropTypes.number,
  rows: PropTypes.number,
  func: PropTypes.func,
  inputProps: PropTypes.object,
};
